import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { guaranteeSteps } from '../../data/content';
import { SectionCTA } from '../SectionCTA';
export function Guarantee() {
  return <section className="w-full bg-white px-4 py-16 sm:px-6 sm:py-20" data-id="element-190" data-mp="24nggo2fd985b">
      <div className="mx-auto max-w-3xl" data-id="element-191" data-mp="24ldjmyfsqer3">
        <div className="flex flex-col items-center text-center" data-id="element-192" data-mp="29e6mthvm9f12">
          <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-go-light" data-id="element-193" data-mp="2ed03tka43o5z">
            <ShieldCheckIcon className="h-7 w-7 text-go-dark" aria-hidden="true" data-id="element-194" data-mp="2efdz9u8pf2e2" />
          </span>
          <h2 className="mt-4 font-display text-3xl font-bold leading-tight text-ink sm:text-4xl" data-id="element-195" data-mp="2jdxhbjk6fu15">
            7-day money-back guarantee
          </h2>
          <p className="mt-2 text-[15px] text-ink-soft" data-id="element-196" data-mp="2sbho180t6ij5">Explore the Workflow Builder risk-free</p>
        </div>

        <ol className="mt-9 grid gap-3 sm:grid-cols-2" data-id="element-197" data-mp="tyr3m7a2h7oc">
          {guaranteeSteps.map((step, i) => <li key={step} className="flex items-start gap-3 rounded-2xl border border-navy-100 bg-cream px-4 py-3.5" data-id="element-198" data-mp="xz1kiezedihz" data-mpi={i}>
              <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-navy-600 text-[11px] font-bold text-white" data-id="element-199" data-mp="3nugcialeksvw">
                {i + 1}
              </span>
              <span className="text-[14.5px] leading-snug text-ink" data-id="element-200" data-mp="3dx29pdsek2m2">{step}</span>
            </li>)}
        </ol>

        <div className="mt-8 space-y-3 text-center text-[15px] leading-relaxed text-ink-soft" data-id="element-201" data-mp="fdvbbfz0j43c">
          <p data-id="element-202" data-mp="agv6179zm5da">
            See whether Dr. Karito’s system gives you a clearer way to organize complex DVO cases.
          </p>
          <p data-id="element-203" data-mp="5f5vrtul9vq9">
            If within 7 days you decide the Workflow Builder isn’t right for you, simply request a
            refund.
          </p>
          <p className="text-[13px] font-bold uppercase tracking-[0.1em] text-ink" data-id="element-204" data-mp="2q6pv5k2nj7mi">
            No long-term commitment · No subscription · No risk
          </p>
        </div>

        <SectionCTA transformation="Decide after you’ve used it, not before." label="Try it risk-free" subline="7 days to decide · Full refund on request" data-id="element-205" data-mp="2la7ryomyzhca" />
      </div>
    </section>;
}